<span class="label">
    {{ label }}
    <span *ngIf="!readOnly" class="hint">
        Files must be smaller than 30 MB and have one of the following extensions: docx, doc, gif, jpg, jpeg, pdf, png,
        rtf, txt, xls, xlsx, ppt, pptx
    </span>
</span>
<span class="control">
    <span *ngIf="readOnly && !controlFiles.length" class="no-data">No attachments</span>
    <cm-files-list
        *ngIf="controlFiles.length"
        [files]="controlFiles"
        [allowedTypes]="allowedTypes"
        [maxSize]="FILE_SIZE"
        [compact]="true"
        [showControls]="!readOnly"
        [showLoadingData]="true"
        (removeFile)="onRemove($event)"
    >
    </cm-files-list>
    <cm-file-input
        class="file-input"
        *ngIf="!readOnly"
        [allowedTypes]="allowedTypes"
        (change)="onFilesSelect($event)"
    ></cm-file-input>
</span>
